import { render } from "./feedbackModal.vue?vue&type=template&id=69883293&ts=true"
import script from "./feedbackModal.ts?vue&type=script&lang=ts"
export * from "./feedbackModal.ts?vue&type=script&lang=ts"

import "./feedbackModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__